import { useAsyncData, useRuntimeConfig } from '#app'

import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'

export function useProductListRating(id: string) {
  const $httpFetch = useHttpFetch()
  const { isBrowser } = useRuntimeConfig().public

  return useAsyncData(
    `product-rating-${id}`,
    () =>
      $httpFetch('/reviews/product-landings/:uuid/products/reviews-summary', {
        pathParams: { uuid: id },
        ...(!isBrowser && { timeout: 500 }),
      }),
    {
      default: () => null,
    },
  )
}
